import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageUtils } from '@app/MessageUtils';
import { SessionStorageService } from '@mova/components/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient, private _sessionStorageService:SessionStorageService, private _apiService:ApiService) { }

  private pathLogin: string = '/usuario/controlAcceso/';
  private url: string = this._apiService.server;
  /**
   * Comprueba si el usuario está 'logueado'
   * @returns true si está logueado.
   * @returns false si no lo está.
   */
  isLogged() {
    if (this._sessionStorageService.getItem(MessageUtils.DATA_USER) !=null) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Elimina los datos de sesión de usuario.
   */
  deleteSessionData() {
    if (this._sessionStorageService.getItem(MessageUtils.DATA_USER)) {
      this._sessionStorageService.clearItem(MessageUtils.DATA_USER);
    }
  }

  /**
   * Login Fake.
   * @returns User si existe.
   */
   login(cdNifNie:String, cdMailUniversidad:String):Observable<any> {
    let url = this.url+this.pathLogin+cdNifNie+"/"+cdMailUniversidad;
    return this._apiService.postSinBody(url);
  }

}
